import { jsx as _jsx } from "react/jsx-runtime";
import { FormControlLabel, Switch } from '@mui/material';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { select_ui_settings, set_ui_settings } from 'console/redux/settings-actions';
export const GeneralEventsSwitcher = () => {
    const { dashboard_settings } = useAppSelector(select_ui_settings);
    const setUiSettings = useAction(set_ui_settings);
    const events_general = dashboard_settings?.events_general;
    function onSwitchChange() {
        setUiSettings({ dashboard_settings: { events_general: !events_general } });
    }
    return (_jsx(FormControlLabel, { control: _jsx(Switch, { checked: events_general, onChange: onSwitchChange }), label: "\u041E\u0431\u0449\u0438\u0439 \u0432\u0438\u0434", sx: {
            m: '0',
            '& > span': {
                fontWeight: 'bold',
                fontSize: '14px',
            },
            '@media (max-width: 395px)': {
                '& > span': {
                    fontSize: '10px',
                },
            },
        } }));
};
